
import { StytchProvider as ProviderActual } from '@stytch/nextjs';
import { createStytchUIClient } from '@stytch/nextjs/ui';
const domain = process.env.NEXT_PUBLIC_DOMAIN;
const stytchOptions = {
  cookieOptions: {
    availableToSubdomains: true,
    ...(domain ? { domain: domain } : {}),
  },
};
const stytch = createStytchUIClient(
  process.env.NEXT_PUBLIC_STYTCH_API_KEY || '',
  stytchOptions
);



interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pageProps: Record<string, any>
}

export const StytchProvider: React.FC<React.PropsWithChildren<Props>> = ({
  children,
}) => {

  return (
  
      <ProviderActual stytch={stytch}>
        {children}
      </ProviderActual>
  )
}

export default StytchProvider